var _style, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrumlrActionbarMod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 152,
    height: 344,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".B{stroke-linejoin:round}.C{stroke-width:1.5}.D{stroke-width:2}.E{stroke-linecap:round}.F{fill:rgba(255,255,255,0)}.G{stroke:#E20360}.H{stroke-linecap:square}.I{stroke:rgba(255,0,105,0.5)}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "A",
    x: 0,
    y: 0,
    width: 152,
    height: 344
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "A"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#E20360",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "A"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.844-13.349v-9.468a1.183 1.183 0 0 1 2.366 0v4.317m-2.31 9.823l-5.489-5.737a1.183 1.183 0 0 1 .532-1.597 1.183 1.183 0 0 1 .91-.067c.3.1.385.046.525.329l3.464 2.4m2.366-4.737a1.183 1.183 0 0 1 2.366 0m.03 0c0-.653.5-.591 1.153-.591a1.183 1.183 0 0 1 1.183 1.183",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48 32)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48 -32)",
    filter: "url(#A)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 248,
    rx: 28,
    transform: "translate(48 32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 80h32v32H12z",
    className: "F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    className: "B D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.662 89.954a8.01 8.01 0 0 0-7.054 14.248 8.01 8.01 0 0 0 10.236-12.165l1.717-1.537"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.662 89.954a8.01 8.01 0 0 0-7.054 14.248 8.01 8.01 0 0 0 10.236-12.165",
    className: "E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 87.039V87a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v.081",
    className: "C H"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28 98v-4",
    stroke: "rgba(255,0,104,0.5)",
    className: "C E"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 136h32v32H12z",
    className: "F"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109.286 170)",
    clipPath: "url(#B)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.247-25h14.695V-7.677H128.247Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    className: "B E"
  }, /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.558 156.651v-9.468c0-.653.53-1.183 1.183-1.183s1.183.53 1.183 1.183v4.317m-2.306 9.823l-5.49-5.736c-.143-.282-.168-.61-.068-.91a1.18 1.18 0 0 1 .6-.687c.284-.139.61-.168.91-.068s.385.046.525.329l3.464 2.4m2.365-4.737c0-.653.53-1.183 1.183-1.183s1.183.53 1.183 1.183m.03 0c0-.653.5-.591 1.153-.591s1.183.53 1.183 1.183m-7.039 8.818a2.99 2.99 0 0 0 2.543 1.419h3.9a2.96 2.96 0 0 0 2.091-.866c.555-.554.866-1.307.866-2.091v-6.097c0-.654-.956-1.42-1.609-1.42",
    className: "C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.714 146a4 4 0 1 0-8 0",
    className: "D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.378 149.639a4 4 0 0 0-1.682-7.637 4 4 0 0 0-1.618 7.651",
    className: "D I"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 24h32v32H12z",
    className: "F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.088 48V33a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1z",
    className: "D G"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.207 32h0 .881a1 1 0 0 1 1 1v15a1 1 0 0 1-1 1H18m19.881-17h0H37a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h1.088",
    className: "C I"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M12 192h32v32H12z",
    className: "F"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    className: "G"
  }, /*#__PURE__*/React.createElement("g", {
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.475 205.477l-5 4.989",
    className: "B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.475 205.466h2.989l.011.011v2.989",
    className: "H"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.363 203.528a1.82 1.82 0 0 1 1.6-1.974h15.8a1.82 1.82 0 0 1 1.6 1.974v12.052a1.82 1.82 0 0 1-1.6 1.974h-15.8a1.82 1.82 0 0 1-1.6-1.974z",
    className: "B D"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#ff7eb4",
    className: "C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.975 214.466l13.848-.228",
    className: "B E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.001 198h.931c2.247 0 5.069 2.751 5.069 4.912v1.515"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrumlrActionbarMod);
export default __webpack_public_path__ + "static/media/scrumlr_actionbar_mod.fe9fba0df6b0775694955754cfe1a7c3.svg";
export { ForwardRef as ReactComponent };